interface StatCard {
  icon: string;
  value: string;
  label: string;
  description: string;
}

const stats: StatCard[] = [
  {
    icon: 'ri-water-flash-line',
    value: '6,400',
    label: 'Surface Acres',
    description: 'One of north Louisiana\'s largest reservoirs',
  },
  {
    icon: 'ri-arrow-down-double-line',
    value: '28 ft',
    label: 'Max Depth',
    description: 'Deep, clear water ideal for fishing & swimming',
  },
  {
    icon: 'ri-anchor-line',
    value: '15+',
    label: 'Fish Species',
    description: 'Bass, crappie, catfish, bream & more',
  },
  {
    icon: 'ri-sun-line',
    value: '218',
    label: 'Sunny Days/Year',
    description: 'Perfect weather for outdoor adventures',
  },
  {
    icon: 'ri-map-pin-2-line',
    value: '3,000+',
    label: 'Acres of Park',
    description: 'Lake Claiborne State Park surrounds the lake',
  },
  {
    icon: 'ri-road-map-line',
    value: '47 mi',
    label: 'Shoreline',
    description: 'Miles of scenic, pine-lined shoreline',
  },
];

export default function LakeStatsSection() {
  return (
    <section id="stats" className="w-full py-24 md:py-32 px-4" style={{ background: 'linear-gradient(160deg, #e8f4f8 0%, #f0fafa 50%, #ffffff 100%)' }}>
      <div className="max-w-6xl mx-auto">

        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-teal-600 text-xs font-bold tracking-widest uppercase mb-3">By the Numbers</p>
          <h2 className="font-serif text-4xl md:text-5xl text-slate-800 leading-tight">
            Lake Claiborne at a Glance
          </h2>
          <p className="text-slate-500 text-lg mt-4 max-w-xl mx-auto">
            A few reasons why Lake Claiborne is Louisiana's best-kept secret — and why rental properties here are in high demand.
          </p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="bg-white rounded-2xl p-8 flex flex-col items-center text-center group hover:-translate-y-1 transition-transform duration-300"
            >
              <div className="w-16 h-16 flex items-center justify-center rounded-full bg-teal-50 text-teal-600 mb-5 group-hover:bg-teal-500 group-hover:text-white transition-colors duration-300">
                <i className={`${stat.icon} text-2xl`} />
              </div>
              <span className="font-bold text-5xl text-slate-800 leading-none mb-2">{stat.value}</span>
              <span className="text-teal-600 text-xs font-bold tracking-widest uppercase mb-3">{stat.label}</span>
              <p className="text-slate-500 text-sm leading-relaxed">{stat.description}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
